/* 🤖 this file was generated by svg-to-ts */
export const matIconSlideshow: {
  name: 'slideshow';
  data: string;
} = {
  name: 'slideshow',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10 8v8l5-4-5-4zm9-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"/></svg>`
};
